
<template>
    <div class="row">
        <div class="col-12 ">
            <h3 class="mt-3">{{questionTitle}}</h3>

            <!-- Tool Tip -->
            <div class="small scoring-guidance">
                <div v-if="questionTitle.includes($t('accountConfig.protectiveQualities'))">
                    <span v-if="blnLongText == false">{{ $t('questionnaire.protectiveQualitiesInstruction').slice(0,25) }} ...</span>
                    <span v-if="blnLongText == true">{{ $t('questionnaire.protectiveQualitiesInstruction') }}</span>
                </div>

                <div v-if="questionTitle.includes( $t('reportOverview.hygiene'))">
                    <span v-if="blnLongText == false">{{ $t('questionnaire.hygieneInstruction').slice(0,25) }} ...</span>
                    <span v-if="blnLongText == true">{{ $t('questionnaire.hygieneInstruction') }}</span>
                </div>

                <div v-if="questionTitle.includes( $t('accountConfig.conditionFasteners'))">
                    <span v-if="blnLongText == false">{{ $t('questionnaire.fastenerInstruction').slice(0,25) }} ...</span>
                    <span v-if="blnLongText == true">{{ $t('questionnaire.fastenerInstruction') }}</span>
                </div>

                <button v-if="blnLongText == false" type="button" class="small color-blue" @click="Expand()"><b-icon-chevron-down /> {{ $t('general.expand') }}</button>
                <button v-if="blnLongText == true" type="button" class="small color-blue" @click="Expand()"><b-icon-chevron-up /> {{ $t('general.collapse') }}</button>
            </div>

            <!-- Questionare -->
            <fieldset id="group2" class="">



                <ul class="report-controls mt-5 mb-4">
                    <li>
                        <label class="smiley-radio">
                            <span :class="[{'smiley-label-selected': value == 1},  {'smiley-label-verybad': value == 1}]">
                                {{ $t('questionnaire.veryBad') }}
                            </span>
                            <input v-model="valQuestionnaire" :value="1" type="radio" :name="questionTitle">
                            <span class="smiley-very-bad"></span>
                        </label>
                    </li>
                    <li>
                        <label class="smiley-radio">
                            <span :class="[{'smiley-label-selected': value == 2},  {'smiley-label-bad': value == 2}]">
                                {{ $t('questionnaire.bad') }}
                            </span>
                            <input v-model="valQuestionnaire" :value="2" type="radio" :name="questionTitle" />
                            <span class="smiley-bad"></span>
                        </label>
                    </li>
                    <li>
                        <label class="smiley-radio">
                            <span :class="[{'smiley-label-selected': value == 3},  {'smiley-label-acceptable': value == 3}]">
                                {{ $t('questionnaire.acceptable') }}
                            </span>
                            <input v-model="valQuestionnaire" :value="3" type="radio" :name="questionTitle" />
                            <span class="smiley-acceptable"></span>
                        </label>
                    </li>
                    <li>
                        <label class="smiley-radio">
                            <span :class="[{'smiley-label-selected': value == 4},  {'smiley-label-good': value == 4}]">
                                {{ $t('questionnaire.good') }}
                            </span>
                            <input v-model="valQuestionnaire" :value="4" type="radio" :name="questionTitle" />
                            <span class="smiley-good"></span>
                        </label>
                    </li>
                    <li>
                        <label class="smiley-radio">
                            <span :class="[{'smiley-label-selected': value == 5},  {'smiley-label-verygood': value == 5}]">
                                {{ $t('questionnaire.veryGood') }}
                            </span>
                            <input v-model="valQuestionnaire" :value="5" type="radio" :name="questionTitle" />
                            <span class="smiley-very-good"></span>
                        </label>
                    </li>
                </ul>
            </fieldset>
        </div>
    </div>
</template>

<script>
    import Bus from '@/Bus.js';

    export default {
        name: 'Questionnaire',
        props: ['questionTitle', 'value'],


        data: function () {

            return {
                eventBus: Bus,
                valQuestionnaire: this.value,
                strHygiene: this.$t('questionnaire.hygieneInstruction'),
                strConditionFasteners: this.$t('questionnaire.fastenerInstruction'),
                blnLongText: false,
            }

        },
        mounted: function () {

        },
        methods: {
            Expand: function () {
                this.blnLongText = !this.blnLongText;
            }
        },
        watch: {
            valQuestionnaire: function (newValue) {
                this.$emit('input', newValue)
            },
            value: function (newValue) {
                this.valQuestionnaire = newValue
            }
        },
        computed: {
            //valQuestionnaire: {
            //    get: function () {
            //        return this.value
            //    },
            //    set: function () {
            //        this.$emit("change", this.value)
            //    }
            //}
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
